import { BucketId, FileReference } from '@kaizenplatform/belfast-entity';
import produce from 'immer';

import State from '../core/State';
import initialState from '../initialState';
import { ProjectChangeType } from '../service/persistent/ProjectChangeWebApi';
import { ProjectType } from '../service/persistent/ProjectWebApi';

export const startFetchingProject = () => (state: State): State => ({
  ...state,
  project: {
    ...state.project,
    fetching: state.project.fetching + 1,
  },
});

export const finishFetchingProject = () => (state: State): State => ({
  ...state,
  project: {
    ...state.project,
    fetching: state.project.fetching - 1,
  },
});

export const setProject = (project: ProjectType) => (state: State): State => ({
  ...state,
  project: {
    ...state.project,
    project,
  },
});

export const setAssetFiles = (files: ReadonlyArray<FileReference>) => (state: State): State => ({
  ...state,
  project: {
    ...state.project,
    assetFiles: files,
  },
});

export const setBriefFiles = (files: Map<BucketId, FileReference[]>) => (state: State): State => ({
  ...state,
  project: {
    ...state.project,
    briefFiles: files,
  },
});

export const setProjectChange = (projectChange: ProjectChangeType) => (state: State): State => ({
  ...state,
  project: {
    ...state.project,
    projectChange,
  },
});

export const setLatestBriefFiles = (files: Map<BucketId, FileReference[]>) => (state: State): State => ({
  ...state,
  project: {
    ...state.project,
    latestBriefFiles: files,
  },
});

export const setBeforeBriefFiles = (files: Map<BucketId, FileReference[]>) => (state: State): State => ({
  ...state,
  project: {
    ...state.project,
    beforeBriefFiles: files,
  },
});

export const setAssetFormTermAgreements = (isAgreed: boolean) => (state: State): State => {
  return produce(state, (draft) => {
    // stateにユーザーの同意の有無を保存する → stateの更新させる
    draft.searchAsset.isAssetTermAgreed = isAgreed;
  });
};

export const dispose = () => (state: State): State => ({
  ...state,
  project: {
    ...state.project,
    project: initialState.project.project,
  },
});
